<template>
    <div>
        <div class="row align-items-center asahi-background justify-content-between">
            <div class="px-0 col-7 align-self-center">
                <!-- logo -brand -->
                <span data-toggle="collapse" data-target="#menu">
                    <img :src="$store.state.logoLong" :alt="$store.state.applicationName" class="img-fluid animate__animated animate__rubberBand">
                </span>
            </div>
            <!-- button menu, pic profile -->
            <div class="px-0 col-2 align-self-center" v-if="!$store.state.authUser.guest">
                <div class="p-1 d-flex justify-content-center button-asahi">
                    <!--picture profile-->
                    <img :src='$store.state.authUser.detail.user.picture_profile_url_alternative' alt='' class="shadow img-fluid rounded-circle"/>
                    <!--<div style="color:black;position:absolute;top:50%;left:50%;transform:translate(-50%,0);text-shadow:0px 0px 4px white">NAMA</div>-->
                </div>
            </div>
            <!-- login - register -->
            <div class="px-0 mr-1 col-auto">

                <router-link v-if="$store.state.authUser.guest" tag="button" to="/user-login" class="mb-1 btn btn-sm btn-light" @click.native="collapseMenu()" style="white-space: nowrap;">
                    <font-awesome-icon icon='login-asahi'></font-awesome-icon>
                    Login
                </router-link>
                <div v-else>
                    <div class="mb-1 flex-column d-flex">
                        <div class="badge badge-secondary">{{ $store.state.authUser.detail.user.name }}</div>
                        <div class="badge badge-light">{{ $store.state.authUser.detail.role.name }}</div>
                        <button class="button-asahi btn btn-sm btn-light" style="white-space: nowrap;" @click="logout()">
                            <font-awesome-icon icon='sign-out-alt'></font-awesome-icon>
                            logout
                        </button>
                    </div>
                </div>
            </div>

            <div class="p-2 collapse navbar-collapse bg-primary" id="menu">
                <navbar-menu-list navbarClass="navbar-nav mr-auto text-center" :menuList="$store.getters['page/pageNested']({ showAll : false })" @routerClicked="collapseMenu()"></navbar-menu-list>
            </div>
        </div>
        <!-- quick-menu -->
        <div class="pt-1 text-center row justify-content-center bg-dark quick-menu-mobile">
            <div class="p-0 col-3">
                <router-link :to="{ name: 'sale-form' }" class="px-0">
                    <font-awesome-icon icon="sale-asahi" size="3x"></font-awesome-icon>
                    <div>Penjualan</div>
                </router-link>
            </div>
            <div class="p-0 col-3">
                <router-link :to="{ name: 'purchase-form' }" class="px-0">
                    <font-awesome-icon icon="purchase-asahi" size="3x"></font-awesome-icon>
                    <div>Pembelian</div>
                </router-link>
            </div>
            <div class="p-0 col-3">
                <router-link :to="{ name: 'stock-recap' }" class="px-0">
                    <font-awesome-icon icon="stock-asahi" size="3x"></font-awesome-icon>
                    <div>Saldo Stok</div>
                </router-link>
            </div>
            <div class="p-0 col-3">
                <router-link :to="{ name: 'sale-daily-report' }" class="px-0">
                    <font-awesome-icon icon="report-asahi" size="3x"></font-awesome-icon>
                    <div>Lap. Penj. Harian</div>
                </router-link>
            </div>
        </div>
        <!-- content view : as router later -->
        <div class="mt-3 mb-5 main-content ">
            <transition name="custom-classes-transition"
            :enter-active-class="$store.state.animatedClass.routerTransition.child.enterActiveClass"
            :leave-active-class="$store.state.animatedClass.routerTransition.child.leaveActiveClass"
            :mode="$store.state.animatedClass.routerTransition.child.mode">
            <router-view />
            </transition>
        </div>

        <!--<inspiring-info></inspiring-info>-->

        <footer-side></footer-side>
    </div>
</template>

<script>
    import menuList from './../menuList.json'
//    import InspiringInfo from './childs/InspiringInfo.vue'
    import FooterSide from './childs/Footer.vue'
    import NavbarMenuList from './../asahi/component/NavbarMenuList.vue';
    
    export default {
        name: "HomeMobile",
        components: {
 //           InspiringInfo,
            FooterSide,
            NavbarMenuList
        },
        data() {
            return {
                menuList
            };
        },
        methods : {
            collapseMenu() {
                $('.collapse').collapse('hide');
            },
            async logout() {
                await this.$store.dispatch('authUser/logoutAuth')
                this.$router.push({name : 'welcome'})
            }
        }
    };

</script>

<style lang="scss" scoped>
    .asahi-background {
        background-color: #fdd32aff;
    }

    .button-asahi {
        font-size: 8px;
        /* color: black; */
        /* border: 0; */
        /* background-color: #e7eaec; */
    }

    .active {
        color: #fdd32aff;
    }

    .quick-menu-mobile {
        & div>a {
            text-decoration: none;

            &>div {
                font-size: 12px;
            }
        }
    }

</style>
